import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  filters: {
    modalFiltersRules: undefined,
    modalConditions: undefined,
  },
};
// Actual Slice
export const sellRequestsSlice = createSlice({
  name: 'sellRequests',
  initialState,
  reducers: {
    filtersModalConditionSellRequestsChangeSuccess: (state, { payload }) => {
      state.filters.modalConditions = payload;
      if (!payload?.rules?.length) {
        state.filters.modalFiltersRules = undefined;
      }
    },
    filtersModalRulesSellRequestsChangeSuccess: (state, { payload }) => {
      state.filters.modalFiltersRules = payload;
    },
    resetModalSellRequestsChangeSuccess: (state) => {
      state.filters.modalConditions = null;
      state.filters.modalFiltersRules = null;
    },
  },
});

export const {
  filtersModalConditionSellRequestsChangeSuccess,
  filtersModalRulesSellRequestsChangeSuccess,
  resetModalSellRequestsChangeSuccess,
} = sellRequestsSlice.actions;

export const selectSellRequestsState = (state) => state.sellRequests;

export default sellRequestsSlice.reducer;

export const filtersModalConditionSellRequestsChange = (conditions) => {
  return (dispatch) => {
    dispatch(filtersModalConditionSellRequestsChangeSuccess(conditions));
  };
};
export const filtersModalRulesSellRequestsChange = (rules) => {
  return (dispatch) => {
    dispatch(filtersModalRulesSellRequestsChangeSuccess(rules));
  };
};

export const resetModalSellRequestsChange = () => {
  return (dispatch) => {
    dispatch(resetModalSellRequestsChangeSuccess());
  };
};
